/** Mirrors AUTO_LINK_THRESHOLD / REVIEW_THRESHOLD in backend src/ai/case-matcher.js — keep in sync. */
export const AUTO_LINK_THRESHOLD = 0.85;
export const REVIEW_THRESHOLD = 0.5;

export type MatchTier = 'likely' | 'possible' | 'unlikely';

export function matchTier(score: number): MatchTier {
  if (score >= AUTO_LINK_THRESHOLD) return 'likely';
  if (score >= REVIEW_THRESHOLD) return 'possible';
  return 'unlikely';
}

export const MATCH_TIER_LABEL: Record<MatchTier, string> = {
  likely: 'Likely duplicate',
  possible: 'Possible match',
  unlikely: 'Probably new',
};

/** Below this, linking would almost certainly be wrong — don't let it be selected. */
export function isLinkable(score: number): boolean {
  return score >= REVIEW_THRESHOLD;
}
